import { recordSignupActivity } from "@faire/retailer-visitor-shared/actions/user/recordLoggedOutActivity";
import {
  isFaireDirectVariant,
  AppSignUpModalVariant,
  useAppSignUpModalVariant,
} from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { trackFaireDirectShoppableLandingPageModalCloseClick } from "@faire/web-api--source/events/faireDirect/click/shoppableLandingPageModalClose";
import { trackSignupCloseSignUpModalClick } from "@faire/web-api--source/events/signup/click/closeSignUpModal";
import { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/www/welcome/r/personal";
import { Storage } from "@faire/web/common/Storage";
import { useQueryParams } from "@faire/web/ui/hooks/useQueryParams";
import qs from "qs";
import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { HAS_CLOSED_SIGNUP_MODAL } from "./consts";

const EMPTY_QUERY_FIELDS = {
  signUp: undefined,
  product: undefined,
  brand: undefined,
  video: undefined,
  source: undefined,
  refB: undefined,
  refC: undefined,
  refF: undefined,
  refS: undefined,
  faireMarket: undefined,
};

export const useHandleModalState = () => {
  const history = useHistory();
  const location = useLocation();
  const { faireDirectBrandToken } = useFaireDirectBrand();
  const signUpParams = useQueryParams(SignUpQueryParameters.parse);

  const modalVariant = useAppSignUpModalVariant(signUpParams);

  const handleModalClose = useCallback(() => {
    history.replace({
      ...history.location,
      search: qs.stringify({
        ...signUpParams,
        ...EMPTY_QUERY_FIELDS,
      }),
    });

    if (isFaireDirectVariant(modalVariant)) {
      trackFaireDirectShoppableLandingPageModalCloseClick();
    } else {
      trackSignupCloseSignUpModalClick();
    }

    Storage.session.setItem(HAS_CLOSED_SIGNUP_MODAL, "true");
  }, [history, modalVariant, signUpParams]);

  const recordModalSignUpActivity = useCallback(() => {
    // For leveraging logged out signals from product signups
    if (modalVariant === AppSignUpModalVariant.PRODUCT) {
      recordSignupActivity(
        {
          product_token: signUpParams.product,
          brand_token: signUpParams.brand,
        },
        location.pathname
      );
    } else if (isFaireDirectVariant(modalVariant)) {
      recordSignupActivity(
        {
          brand_token: faireDirectBrandToken,
        },
        location.pathname
      );
    }
  }, [
    faireDirectBrandToken,
    location.pathname,
    modalVariant,
    signUpParams.brand,
    signUpParams.product,
  ]);

  return {
    modalVariant,
    handleModalClose,
    recordModalSignUpActivity,
  };
};
